import {Injectable} from '@angular/core';
import {Effect, Actions} from '@ngrx/effects';
import * as managerAction from '../actions/manager.action';
import {map, switchMap, catchError, mergeMap, take, withLatestFrom, filter} from 'rxjs/operators';
import {of} from 'rxjs/observable/of';
import {Action, Store} from '@ngrx/store';
import {Observable} from 'rxjs/Observable';
import * as fromStore from '../../../store';
import {isNullOrUndefined} from 'util';
import {FreelancersService} from '../../../freelancers/freelancers.service';
import {ManagersService} from '../../managers.service';

@Injectable()
export class ManagerEffect {
  constructor(private actions: Actions,
              private managerService: ManagersService,
              private freelancerService: FreelancersService,
              private store: Store<fromStore.AppState>) {
  }

  @Effect()
  getAllManagers: Observable<Action> = this.actions.ofType(managerAction.GET_ALL_MANAGERS)
    .pipe(
      switchMap(() => {
        return this.managerService.getAllManagers()
          .map(res => new managerAction.GetAllManagersSuccess(res))
          .catch(error => of(new managerAction.GetAllManagersError(error)));
      })
    );
  @Effect()
  getManager: Observable<Action> = this.actions.ofType(managerAction.GET_MANAGER)
    .pipe(
      withLatestFrom(
        // select users.
        this.store.select(state => state.managersFeature.managers.users),
        (action: any, users) => {
          // if no users present, proceed for API.
          if (isNullOrUndefined(users)) {
            return action;
          } else {
            // users exists in store.
            const manager = users.filter(m => m.id === action.payload)[0];
            if (!!manager) {
              // if required user is present in store, then return;
              return undefined;
            } else {
              // if required user not present in store, then proceed for API.
              return action;
            }
          }
        }
      ),
      filter(action => !!action),
      mergeMap(action => {
        return this.freelancerService.getFreelancer(action.payload)
          .map(res => new managerAction.GetManagerSuccess(res))
          .catch(error => of(new managerAction.GetManagerError(error)));
      })
    );
  // .pipe(
  //   switchMap((freelancerId) => {
  //     return new managerAction.GetManager(freelancerId);
  //     // return this.managerService.getManager(freelancerId)
  //     //   .map(res => new managerAction.GetManagerSuccess(res))
  //     //   .catch(error => of(new managerAction.GetManagerError(error)));
  //   })
  // );

  @Effect()
  registerManager: Observable<Action> = this.actions.ofType(managerAction.ADD_MANAGER)
    .map((action: managerAction.AddManager) => action.payload)
    .pipe(
      switchMap(body => {
        return this.freelancerService.registerFreelancer(body)
          .map(res => new managerAction.AddManagerSuccess(res))
          .catch(error => of(new managerAction.AddManagerError(error)));
      })
    );

  @Effect()
  updateManager: Observable<Action> = this.actions.ofType(managerAction.UPDATE_MANAGER)
    .map((action: managerAction.UpdateManager) => action.payload)
    .pipe(
      switchMap(body => {
        return this.freelancerService.updateFreelancer(body)
          .map(res => new managerAction.UpdateManagerSuccess(res))
          .catch(error => of(new managerAction.UpdateManagerError(error)));
      })
    );
}



// WEBPACK FOOTER //
// /Users/Chetan/Downloads/angular5_admin-master/src/app/managers/store/effects/manager.effect.ts